var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayAsYouDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#48E1BB",
    fillRule: "evenodd",
    d: "M2 20.517l7.78 4.235 7.728-4.235 7.555 3.672.113-14.323-7.668-3.524L9.78 9.866 2 5.632v14.885z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.211,
    d: "M25.063 24.189l-7.555-3.671-7.728 4.234L2 20.518V5.632l7.78 4.234 7.728-3.524 7.669 3.524-.114 14.323z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB608",
    fillRule: "evenodd",
    d: "M15.836 8.953c.1.326 1.775 3.398 2.824 5.306.36.66 1.305.66 1.666 0 1.048-1.908 2.723-4.98 2.823-5.306h.001c.183-.594.226-1.25.087-1.929-.301-1.463-1.483-2.648-2.949-2.944-2.46-.495-4.62 1.374-4.62 3.746 0 .392.058.77.168 1.127z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.211,
    d: "M15.836 8.953v0c.1.326 1.775 3.398 2.824 5.306.36.66 1.305.66 1.666 0 1.048-1.908 2.723-4.98 2.823-5.306h.001c.183-.594.226-1.25.087-1.929-.301-1.463-1.483-2.648-2.949-2.944-2.46-.495-4.62 1.374-4.62 3.746 0 .392.058.77.168 1.127z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.605,
    d: "M20.42 6.96c-.133-.415-.524-.714-.983-.71-.565.005-1.018.468-1.013 1.033.01 1.022.533.75.024 2.534l2.057-.02M17.925 8.175l1.573-.017"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB608",
    fillRule: "evenodd",
    d: "M4.728 13.11c.047.156.845 1.619 1.344 2.527.172.314.622.314.795 0 .498-.908 1.296-2.371 1.344-2.527.087-.283.108-.595.042-.918-.144-.697-.707-1.262-1.405-1.402-1.172-.236-2.2.653-2.2 1.783 0 .187.028.368.08.537z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.211,
    d: "M4.728 13.11v0c.047.156.845 1.619 1.344 2.527.172.314.622.314.795 0 .498-.908 1.296-2.371 1.344-2.527v0c.087-.283.108-.595.042-.918-.144-.697-.707-1.262-1.405-1.402-1.172-.236-2.2.653-2.2 1.783 0 .187.028.368.08.537z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#320B42",
    strokeDasharray: ".58 1.74",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.871,
    d: "M6.522 17.79l3.646 2.118 7.567-3.863 2.755 1.199"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayAsYouDrive);
export default __webpack_public_path__ + "static/media/PayAsYouDrive.5115f4eb795d1aa130a7e290a4b51ec0.svg";
export { ForwardRef as ReactComponent };